import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip as WmsTooltip } from "react-tooltip";
import { getAreaByWarehouseId, getBayByWarehouseId, getLevelByWarehouseId, getPositionByWarehouseId, getRowByWarehouseId, getWarehouseBySellerId, getWarehouseListing } from '../../../store/actions/inventory.action';
import DatePickerComponent from '../../common/DatePickerComponent';
import { quantityTextRender, renderConsignmentType, renderTooltip } from '../../../config/utils';
import moment from 'moment';
import PropTypes from "prop-types";
import { LOW_STOCK_THRESHOLD_MAX, LOW_STOCK_THRESHOLD_MIN } from "../../../constant";

const WarehouseDetails = (props) => {
    const {
        handleWarehouse,
        item,
        isEditable,
        handleInputBlur,
        addWarehouse,
        index,
        removeWarehouse,
        updateWareHouseDetails,
        userDetails,
        productForm,
        isProduct,
        error
    } = props;
    const dispatch = useDispatch();
    const { warehouseListBySellerId } = useSelector((state) => state.InventoryManagement);
    const countries = useSelector((state) => state.shipment.countries);

    useEffect(() => {
        fetchWareHousesBySellerId();
        fetchWareHouses();
    }, [userDetails]);

    useEffect(() => {
        if (item.warehouseId) {
            fetchAreaDetails();
        }
    }, [item.warehouseId]);

    useEffect(() => {
        if (item.areaId) {
            fetchRowDetails();
        }
    }, [item.areaId]);

    useEffect(() => {
        if (item.rowId) {
            fetchBayDetails();
        }
    }, [item.rowId]);

    useEffect(() => {
        if (item.bayId) {
            fetchLevelsDetails();
        }
    }, [item.bayId]);

    useEffect(() => {
        if (item.levelId) {
            fetchPositionDetails();
        }
    }, [item.levelId]);

    const fetchPositionDetails = async () => {
        let data = {
            levelId: item.levelId
        }
        let getRowDetailsRes = await Promise.resolve(dispatch(getPositionByWarehouseId(data)));
        if (getRowDetailsRes?.data?.Status === 200) {
            updateWareHouseDetails(index, 'positionList', getRowDetailsRes.data.Entity);
        }
    }

    const fetchLevelsDetails = async () => {
        let data = {
            bayId: item.bayId
        }
        let getRowDetailsRes = await Promise.resolve(dispatch(getLevelByWarehouseId(data)));
        if (getRowDetailsRes?.data?.Status === 200) {
            updateWareHouseDetails(index, 'levelList', getRowDetailsRes.data.Entity);
        }
    }

    const fetchBayDetails = async () => {
        let data = {
            rowId: item.rowId
        }
        let getRowDetailsRes = await Promise.resolve(dispatch(getBayByWarehouseId(data)));
        if (getRowDetailsRes?.data?.Status === 200) {
            updateWareHouseDetails(index, 'bayList', getRowDetailsRes.data.Entity);
        }
    }
    const fetchRowDetails = async () => {
        let data = {
            areaId: item.areaId
        }
        let getRowDetailsRes = await Promise.resolve(dispatch(getRowByWarehouseId(data)));
        if (getRowDetailsRes?.data?.Status === 200) {
            updateWareHouseDetails(index, 'rowList', getRowDetailsRes.data.Entity);
        }
    }

    const fetchAreaDetails = async () => {
        let data = {
            warehouseId: item.warehouseId
        }
        let getAreaDetailsRes = await Promise.resolve(dispatch(getAreaByWarehouseId(data)));
        if (getAreaDetailsRes?.data?.Status === 200) {
            updateWareHouseDetails(index, 'areaList', getAreaDetailsRes.data.Entity);
        }
    }

    const fetchWareHousesBySellerId = () => {
        let data = { "sortOrder": "ASCENDING" }
        dispatch(getWarehouseBySellerId(data));
    }

    const fetchWareHouses = () => {
        let data = { "sortOrder": "ASCENDING" }
        dispatch(getWarehouseListing(data));
    }

    const thresholdErrorKey = `wareHouseThreshold_${index}`;
    const thresholdErrorClass = error?.[thresholdErrorKey] ? "errorField" : "";

    return (
        <div className='row addressForm mb-3' key={item?.id}>
            <div className='col-12 border-col'>
                <div className='row addressForm pl-3 pr-3'>
                    <div className='col-lg-3 col-md-6 col-sm-12 mb-3 zIndex2'>
                        <div>Warehouse Name</div>
                        <div className='d_flex'>
                            <select
                                value={item.warehouseId}
                                className={`form-control countryOfOrigin selectWarehouse`}
                                onChange={(e) => handleWarehouse(e, index)}
                                name='warehouseId'
                                disabled={!isEditable}
                            >
                                <option value={0}>Select Warehouse</option>
                                {warehouseListBySellerId?.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                            {Number(item.warehouseId) > 0 && (
                                <div className='detailBox '>
                                    <i id={`address-${index}`} className="fa fa-address-card-o" aria-hidden="true"></i>
                                    <WmsTooltip
                                        anchorId={`address-${index}`}
                                        data-tooltip-html={true}
                                        place="right"
                                        className="tooltipWidth"
                                    >
                                        <div className='tooltipAddress'>
                                            <p><b>Address</b></p>
                                            <p>{item?.address?.address1}, {item?.address?.zipcode}</p>
                                            <p>{item?.address?.state}, {item?.address?.country}</p>
                                        </div>
                                    </WmsTooltip>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
                        <div>Area</div>
                        <select
                            value={item.areaId}
                            className={`form-control countryOfOrigin mr-3`}
                            onChange={(e) => handleWarehouse(e, index)}
                            name='areaId'
                            disabled={!isEditable}
                        >
                            <option value={0}>Select Area</option>
                            {item?.areaList?.map((item) => (
                                <option key={item.Id} value={item.Id}>{item.AreaCode}</option>
                            ))}
                        </select>
                    </div>
                    <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
                        <div>Row</div>
                        <select
                            value={item.rowId}
                            className={`form-control countryOfOrigin mr-3`}
                            onChange={(e) => handleWarehouse(e, index)}
                            name='rowId'
                            disabled={!isEditable}
                        >
                            <option value={0}>Select Row</option>
                            {item?.rowList?.map((item) => (
                                <option key={item.Id} value={item.Id}>{item.RowCode}</option>
                            ))}
                        </select>
                    </div>
                    <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
                        <div>Bay</div>
                        <select
                            value={item.bayId}
                            className={`form-control countryOfOrigin mr-3`}
                            onChange={(e) => handleWarehouse(e, index)}
                            name='bayId'
                            disabled={!isEditable}
                        >
                            <option value={0}>Select Bay</option>
                            {item?.bayList?.map((item) => (
                                <option key={item.Id} value={item.Id} title={item.BayCode}>{item.BayCode}</option>
                            ))}
                        </select>
                    </div>

                </div>
                {isProduct && (
                    <div className='row addressForm pl-3 pr-3'>
                        <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
                            <div>Level</div>
                            <select
                                value={item.levelId}
                                className={`form-control countryOfOrigin mr-3`}
                                onChange={(e) => handleWarehouse(e, index)}
                                name='levelId'
                                disabled={!isEditable}
                            >
                                <option value={0}>Select Level</option>
                                {item?.levelList?.map((item) => (
                                    <option key={item.Id} value={item.Id}>{item.LevelCode}</option>
                                ))}
                            </select>
                        </div>
                        <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
                            <div>Position</div>
                            <select
                                value={item.positionId}
                                className={`form-control countryOfOrigin mr-3`}
                                onChange={(e) => handleWarehouse(e, index)}
                                name='positionId'
                                disabled={!isEditable}
                            >
                                <option value={0}>Select Position</option>
                                {item?.positionList?.map((item) => (
                                    <option key={item.Id} value={item.Id}>{item.PositionCode}</option>
                                ))}
                            </select>
                        </div>
                        <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
                            <div>Available Quantity</div>
                            <input
                                className='form-control'
                                type={'text'}
                                name="quantity"
                                value={item.quantity}
                                onChange={(e) => handleWarehouse(e, index)}
                                onBlur={handleInputBlur}
                                disabled={!isEditable}
                            />
                            {Number(item.thresholdQuantity) > 0 &&
                                Number(item.quantity) <= Number(item.thresholdQuantity) && (
                                    <span className="error smallTxt">Low stock</span>
                                )}
                        </div>

                        <div className='col-lg-3 col-md-6 col-sm-12 mb-3'>
                            <div>
                                Low-Stock Threshold{" "}
                                <span className="smallTxt">(0 disables alerts)</span>
                            </div>
                            <input
                                className={`form-control ${thresholdErrorClass}`}
                                type={"number"}
                                name="thresholdQuantity"
                                value={item.thresholdQuantity ?? 0}
                                onChange={(e) => handleWarehouse(e, index)}
                                disabled={!isEditable}
                                min={LOW_STOCK_THRESHOLD_MIN}
                                max={LOW_STOCK_THRESHOLD_MAX}
                                onKeyDown={(evt) =>
                                    ["e", "E", "+", "-", "."].includes(evt.key) &&
                                    evt.preventDefault()
                                }
                            />
                            <div className="error">{error?.[thresholdErrorKey]}</div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-12 mb-3">
                            <div className="input-box">
                                <div className="input-label-txt">
                                    Product Expiry
                                </div>
                                <div>
                                    <DatePickerComponent
                                        disabled={!isEditable}
                                        className="form-control receivedDate"
                                        onChange={(date) =>
                                            handleWarehouse({ target: { value: date, name: 'productExpiry' } }, index)
                                        }
                                        value={moment(item.productExpiry).format(
                                            "MM-DD-YYYY"
                                        )}
                                        name={"productExpiry"}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-12 col zIndex1">
                            <div>Storage Id</div>
                            <input
                                className={`form-control storageId`}
                                type={"text"}
                                onBlur={handleInputBlur}
                                name="storageId"
                                value={item?.storageId}
                                onChange={(e) => handleWarehouse(e, index)}
                                disabled={!isEditable}
                            />
                        </div>

                        <div className='col-2 iconBtns col'>
                            <button
                                className="addplusicon"
                                onClick={addWarehouse}
                                disabled={!isEditable}
                            >
                                <i className="fa fa-plus-circle fsIcon" aria-hidden="true"></i>
                            </button>
                            {productForm?.wareHouseDetails?.length > 1 &&
                                <button
                                    className="addplusicon removeParcel"
                                    onClick={(e) => removeWarehouse(index)}
                                    disabled={!isEditable}
                                >
                                    <i className="fa fa-minus-circle fsIcon" aria-hidden="true"></i>
                                </button>
                            }
                        </div>
                    </div>
                )}
                {!isProduct && (
                    <>
                        <div className='row pl-3 pr-3'>
                            <div className='col-lg-2 col-md-6 col-sm-12 mb-3 zIndex2'>
                                <div>Item Expiration</div>
                                <div className='d_flex'>
                                    <DatePickerComponent
                                        data-testid={'itemExpiryDate'}
                                        className="form-control itemExpiryDate"
                                        dateFormat="MM-dd-yyyy"
                                        selected={item?.itemExpiryDate ? new Date(item?.itemExpiryDate) : null}
                                        name="itemExpiryDate"
                                        onChange={(e) => handleWarehouse({ target: { value: e, name: 'itemExpiryDate' } }, index)}
                                        disabled={!isEditable}
                                    />
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-12 mb-3'>
                                <div>Country Of Origin</div>
                                <div className='d_flex'>
                                    <select
                                        value={item.countryOfOrigin}
                                        className={`form-control countryOfOrigin`}
                                        name='countryOfOrigin'
                                        disabled={!isEditable}
                                        onChange={(e) => handleWarehouse(e, index)}

                                    >
                                        <option>Select Country</option>
                                        {countries?.map((country) => (
                                            <option
                                                value={country.iSO}
                                                key={country.id}
                                            >
                                                {country.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-12 mb-3'>
                                <div>Seller Location</div>
                                <div className='d_flex'>
                                    <input
                                        className='form-control'
                                        type={'text'}
                                        name="sellerLocation"
                                        value={item.sellerLocation}
                                        onChange={(e) => handleWarehouse(e, index)}
                                        onBlur={handleInputBlur}
                                        disabled={!isEditable}
                                    />
                                </div>
                            </div>
                            <div className='col-lg-2 col-md-6 col-sm-12 mb-3'>
                                <div>Supplier Code</div>
                                <div className='d_flex'>
                                    <input
                                        className='form-control'
                                        type={'text'}
                                        name="supplierCode"
                                        value={item.supplierCode}
                                        onChange={(e) => handleWarehouse(e, index)}
                                        min={0}
                                        disabled={!isEditable}
                                    />
                                </div>
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12 mb-3'>
                                <div>Notes</div>
                                <div className='d_flex'>
                                    <input
                                        className='form-control'
                                        type={'text'}
                                        name="comments"
                                        value={item.comments}
                                        onChange={(e) => handleWarehouse(e, index)}
                                        disabled={!isEditable}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='row warehouseWrapper pl-3 pr-3'>
                            <div className='col-lg-4 col-sm-12 col zIndex1'>
                                <div className='mr-1'>{renderConsignmentType(productForm.consignmentTypeId, true, Number(item.quantity))} <span className='error'>*</span> </div>
                                {Number(productForm.consignmentTypeId) === 3 && <>
                                    <i className="fa fa-info-circle" aria-hidden="true" id={`mainQuantity-${item?.id}`}></i>
                                    <WmsTooltip
                                        anchorId={`mainQuantity-${item?.id}`}
                                        content={quantityTextRender(item.quantity)}
                                        place="bottom"
                                        className="tooltipTxt"
                                    />
                                </>}
                                {userDetails?.Value?.isSuperAdmin && (
                                    <input
                                        className={`form-control quantity`}
                                        type={"number"}
                                        min={0}
                                        onBlur={handleInputBlur}
                                        onKeyDown={(evt) => ["e", '.', "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                        name="quantity"
                                        value={item.quantity}
                                        onChange={(e) => handleWarehouse(e, index)}
                                        disabled={!isEditable}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                )}
                                {!userDetails?.Value?.isSuperAdmin && (
                                    <span
                                        className='form-control disabledField'
                                        name="quantity"
                                    >
                                        {item.quantity}
                                    </span>
                                )}
                            </div>

                            {Number(productForm.consignmentTypeId) !== 3 && (
                                <>
                                    <div className="col-lg-4 col-sm-12 zIndex2">
                                        <div>Sub Qty{renderConsignmentType(productForm.consignmentTypeId, false)} {' '}
                                            <>
                                                <i className="fa fa-info-circle" aria-hidden="true" id={`quantity-${item?.id}`}></i>
                                                <WmsTooltip
                                                    anchorId={`quantity-${item?.id}`}
                                                    content={renderTooltip(Number(productForm.consignmentTypeId), Number(item.subQuantity))}
                                                    place="right"
                                                    className="tooltipTxt"
                                                />
                                            </>
                                        </div>
                                        <input
                                            className={`form-control subQuantity`}
                                            type={"number"}
                                            min={0}
                                            onBlur={handleInputBlur}
                                            onKeyDown={(evt) => ["e", '.', "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                            name="subQuantity"
                                            value={item.subQuantity}
                                            onChange={(e) => handleWarehouse(e, index)}
                                            disabled={!isEditable}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </div>

                                    <div className="col-lg-4 col-sm-12 zIndex1">
                                        <div>Sub Qty - Items (Total qty of items in Boxes)</div>
                                        <input
                                            className={`form-control subQuantityItem`}
                                            type={"number"}
                                            min={0}
                                            onBlur={handleInputBlur}
                                            onKeyDown={(evt) => ["e", '.', "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                                            name="tertiarySubQuantity"
                                            value={item?.tertiarySubQuantity}
                                            onChange={(e) => handleWarehouse(e, index)}
                                            disabled={!isEditable}
                                            onWheel={(e) => e.target.blur()}
                                        />
                                    </div>
                                </>
                            )}
                            <div className="col-lg-4 col-sm-12 col zIndex1">
                                <div>Storage Id</div>
                                <input
                                    className={`form-control storageId`}
                                    type={"text"}
                                    onBlur={handleInputBlur}
                                    name="storageId"
                                    value={item?.storageId}
                                    onChange={(e) => handleWarehouse(e, index)}
                                    disabled={!isEditable}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-12 col zIndex1">
                                <div>
                                    Low-Stock Threshold{" "}
                                    <span className="smallTxt">(0 disables alerts)</span>
                                </div>
                                <input
                                    className={`form-control ${thresholdErrorClass}`}
                                    type={"number"}
                                    name="thresholdQuantity"
                                    value={item.thresholdQuantity ?? 0}
                                    onChange={(e) => handleWarehouse(e, index)}
                                    disabled={!isEditable}
                                    min={LOW_STOCK_THRESHOLD_MIN}
                                    max={LOW_STOCK_THRESHOLD_MAX}
                                    onKeyDown={(evt) =>
                                        ["e", "E", "+", "-", "."].includes(evt.key) &&
                                        evt.preventDefault()
                                    }
                                    onWheel={(e) => e.target.blur()}
                                />
                                {Number(item.thresholdQuantity) > 0 &&
                                    Number(item.quantity) <= Number(item.thresholdQuantity) && (
                                        <span className="error smallTxt">Low stock</span>
                                    )}
                                <div className="error">{error?.[thresholdErrorKey]}</div>
                            </div>
                            <div className='col-1 iconBtns col'>
                                <button
                                    className="addplusicon"
                                    onClick={addWarehouse}
                                    disabled={!isEditable}
                                >
                                    <i className="fa fa-plus-circle fsIcon" aria-hidden="true"></i>
                                </button>
                                {productForm?.wareHouseDetails?.length > 1 &&
                                    <button
                                        className="addplusicon removeParcel"
                                        onClick={(e) => removeWarehouse(index)}
                                        disabled={!isEditable}
                                    >
                                        <i className="fa fa-minus-circle fsIcon" aria-hidden="true"></i>
                                    </button>
                                }
                            </div>
                        </div>
                    </>
                )}
            </div >
        </div >
    );
}

WarehouseDetails.propTypes = {
    handleWarehouse: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    handleInputBlur: PropTypes.func.isRequired,
    addWarehouse: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    removeWarehouse: PropTypes.func.isRequired,
    updateWareHouseDetails: PropTypes.func.isRequired,
    userDetails: PropTypes.object.isRequired,
    productForm: PropTypes.object.isRequired,
    isProduct: PropTypes.bool.isRequired,
    error: PropTypes.object
};

export default WarehouseDetails;